export default "/EncodeSans_SemiCondensed-Regular.cc649592-f6a5df.ttf";